import React, { useRef } from "react";
import { MultiSelect } from "react-multi-select-component";
import swal from 'sweetalert'
import {
    AccountReducerAction,
    ClearProductCode,
    FetchSingleRecordAction,
    TierListReducerAction,
    addUserAction,
    clearGetSingleProjectDatabase,
    clearProjectId,
    popUpUpdate,
    updateAcccountReducerAction,
} from "../../../store/actions/createTicketManageFields";
import {
    OneSiteDatabase,
    OneSiteDatabaseProjectCode,
    OneSiteDatabaseProjectId,
    accountApi,
    ixModule,
    managEngineer,
    ranDashboard,
    singleProjectApi,
    siteDblistSiteId,
    allTechnologyApi,
    runMpim,
    tmoDallas,
    technology
} from "../../../common/config";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import DatePicker from "react-datepicker";
import {
    columnsArray,
    commonzone,
    fun_time_zonechanger,
    moment_common_full_date_format,
    reformArray,
} from "../../../common/variables";
import AdvancedCommonCrew from "../Forms/Ran Form/advancedcommoncrew";
import { useAsyncDebounce } from "react-table";
import { useHistory } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import Advcommoncrewupdated from "../Forms/Ran Form/advcommoncrewupdated";
import Swal from "sweetalert2";

// import DatePicker from "react-datepicker";
const moment = require("moment");



const TmoDallas = () => {
    // const { watch } = useForm();
    // const selectedStatus = watch('status');
    const formData = new FormData();
    let history = useHistory();

    let allProjects = [];
    let accountArry = [];
    let newTtempArray = [];
    let projectIdArray = [];
    let multipleTechno = [];
    let technologyArray = [];
    let handleMarket = [];
    let mStatusArry =
        [{ label: 'A', value: 'A' },
        { label: 'B', value: 'B' },
        { label: 'C', value: 'C' },
        { label: 'D', value: 'D' },
        { label: 'E', value: 'E' },
        { label: 'F', value: 'F' },];

    let caseStatusarry =
        [{ label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        ];

    let dispatch = useDispatch();

    const [closer, setCloser] = useState(false);




    let [sow, setSow] = useState({
        selectedSow: [],
        sowList: [
            {
                label: "IX",
                value: "IX",
            },
            // {
            //   label: "NEA",
            //   value: "NEA"
            // },
            {
                label: "Troubleshooting",
                value: "Troubleshooting",
            },
            {
                label: "Call Test(PSAP/Speed Test)",
                value: "Call Test(PSAP/Speed Test)",
            },
        ],
        errorState: false,
    });
    let [selectedStatus, SetselectedStatus] = useState()

    let [showReason, setShowReason] = useState(false);
    let [marketts, setmarketts] = useState([])
    let disableRef = useRef(false);
    let [disableButton, setDisable] = useState(false);
    let [singleSitestate, setsingleSitestate] = useState([]);

    let [customesite, setcustomesite] = useState("");
    let [post, setPost] = useState([]);
    let [oneprid, setoneprid] = useState("");
    let [ppProjectId, setppProjctId] = useState("");
    let [SelselectProjectCode, setSelProjectCode] = useState([]);
    let [selectProjectId, setProjectId] = useState([]);
    let [siteError, setSiteError] = useState(false);
    let [ctrCount, setCtrCount] = useState(1);
    const [setdate, setStartDate] = useState();
    const [EngineerOpen, setEngineerOpen] = useState([]);
    const [fstartdate, setfstartdate] = useState();
    const [date, dfefdewdewdate] = useState(null)
    const [subtractedDate, setSubtractedDate] = useState(null);
    const [subtractedDays, setSubtractedDays] = useState(null);






    const [reassigned_date, dfedate] = useState(null)
    let [selectProjectCode, setProjectCode] = useState([]);
    let [startDateError, setStartDateError] = useState(false);
    let [Case, setcase] = useState([])
    let [tech_affected, setTech] = useState([]);

    console.log('fhfgjygj', date)
    let siteArray = [];
    let projectCodeOption = [];
    let siteInfo = [];
    let engineerArray = [];
    let options = useSelector((state) => {
        let technology = state.OneCommonResponse.technologyName;
        //let technologies=state.OneCommonResponse.technologyName
        console.log(technology, 'technologies')
        let sites_Id = state?.OneCommonResponse?.site_id;
        console.log(sites_Id, "hshshhs");
        let site_idss = sites_Id?.map((p) => {
            console.log(p.site_id, "hushuhushus");
            return <option>{p?.site_id}</option>;
        });
        // let technologiesname=technology?.map((items)=>
        // {
        //     console.log(items,'ujujujujuju')
        //     return{
        //         label:items?.technologyName,
        //         value:items?.technologyName,
        //         uniqueid:items?._id,
        //     }
        // })



        if (technology?.length > 0) {
            multipleTechno = [];
            if (technology.length > 0) {
                console.log("comeToStart");
                // setmultiTechnology([])
                console.log(technology, "technology");
                multipleTechno = technology.map((ids) => {
                    // console.log("the ids -=", ids)
                    // let pId = {
                    //   label: ids.label,
                    //   value: ids.label,
                    //   disabled: true
                    // }
                    // multipleTechno.push(pId)
                    // let tmpArry = []
                    // tmpArry = technology.map((item) => {
                    return {
                        value: ids.technologyName,
                        label: ids.technologyName,
                        id: ids._id,
                    };
                    // });

                    // multipleTechno.push(...tmpArry)
                    // setmultiTechnology(multiTechnologylcl)
                });
                console.log(multipleTechno, "multiTechnologymultiTechnology");

                // settechsetter(false)
            }
            // }
        }

        siteInfo = state.csvResponse.singleSite;

        console.log("th e stacdsfcsd=", siteInfo);
        // console.log( siteInfo, siteInfo.length != 0, "ctrCount")
        if (ctrCount == 1 && siteInfo && siteInfo.length != 0) {
            console.log("the single site is =", siteInfo);
            setsingleSitestate(siteInfo);
            setCtrCount(2);
        }
        allProjects = state.CommonResponse.startAwaitedSite;
        console.log("all projects is =", allProjects);
        if (allProjects && allProjects.length > 0) {
            siteArray = allProjects.map((project) => {
                // console.log("the project is =========",project)
                return <option>{project.siteId}</option>;
            });
        }
        let account = state.CommonResponse.accounts;
        if (account.length > 0 && accountArry.length == 0) {
            accountArry = account.map((item) => {
                return <option value={item.uniqueid}>{item.accountName}</option>;
            });
        }
        let tier = state.CommonResponse.listtier;
        if (tier && tier.length != 0) {
            engineerArray = tier.map((item) => {
                return <option>{item.name}</option>;
            });
        }
        projectIdArray = state.OneCommonResponse.productId;
        if (projectIdArray && projectIdArray.length > 0) {
            let projectIdOption = projectIdArray.map((item, index) => {
                let availableId = [];
                let anyArry = item.data;
                availableId = item.data.map((id) => {
                    return {
                        label: id.projectId,
                        value: id.uniqueid,
                    };
                });

                newTtempArray.push({
                    label: item.projectCode,
                    value: item.projectCode,
                    disabled: true,
                });
                newTtempArray.push(...availableId);
            });
        }

        if (state.popUpState) {
            // console.log(state.popUpState.popstatus.status==201,"popUpStatestatus")
            if (
                (state.popUpState.popstatus.status == 201 ||
                    state.popUpState.popstatus.status == 200) &&
                closer
            ) {
                setCloser(false);
                popUpUpdate({});

                // dispatch(AccountReducerAction(ixModule))
                // dispatch(AccountReducerAction(ixModule + "?ix=calender"));
                // history.push("a", { reload: true });
            }
        }

        let projectCodeArray = state.OneCommonResponse.productCode;
        if (projectCodeArray && projectCodeArray.length > 0) {
            projectCodeOption = projectCodeArray.map((item, index) => {
                console.log(
                    SelselectProjectCode,
                    item.projectCode,
                    SelselectProjectCode.indexOf(item.projectCode),
                    selectProjectCode.findIndex((abcd) => {
                        console.log(abcd);
                        return item.projectCode == abcd.label;
                    }),
                    "SelselectProjectCode"
                );
                if (
                    SelselectProjectCode.indexOf(item.projectCode) >= 0 &&
                    selectProjectCode.findIndex((abcd) => {
                        return item.projectCode == abcd.label;
                    }) == -1
                ) {
                    selectProjectCode.push({
                        value: item.uniqueid,
                        label: item.projectCode,
                    });
                }
                return {
                    value: item.uniqueid,
                    label: item.projectCode,
                };
            });
        }
        return { siteArray, projectCodeOption, engineerArray, accountArry, multipleTechno, site_idss };
    });

    const accountss = useSelector(state => state.OneCommonResponse.accounts)

    const marketnames = useSelector(state => state.OneCommonResponse.marketName)

    const engineers = useSelector(state => state.OneCommonResponse.engineers)

    const techname = useSelector(state => state.OneCommonResponse.technologyName)

    const siteid = useSelector(state => state.OneCommonResponse.site_id)
    // const gc = useSelector(state => state.OneCommonResponse.gc_name)
    const gc = useSelector(state => state.OneCommonResponse.gc_company)



    const [alersdadsa, setalersdadsa] = useState();

    console.log("the site id --dwef=", options.siteArray);
    const techChangleHandler = (e) => {
        console.log("Pow multiple select=", e);
        setTech(e);
    };
    const postChangleHandler = (e) => {
        console.log("Pow multiple select=", e);
        setPost(e);
    };

    const findDSiteId = (id) => {
        console.log(id, "findDSiteId", allProjects);
        if (id != undefined && customesite != id) {
            setcustomesite(id);
            setoneprid("");
            setppProjctId("");
            setTech([]);
            setProjectId([]);
            setProjectCode([]);
            dispatch(clearGetSingleProjectDatabase());
            dispatch(clearProjectId());
            dispatch(ClearProductCode());
            // projectData.singleSite = []
            if (allProjects.length > 0)
                console.log(
                    "the respasfsdvgfdsbdtrh =",
                    ...allProjects.filter((item) => item.siteId == id)
                );
            let idObject = allProjects.filter((item) => item.siteId == id);
            if (idObject.length > 0) {
                // setond(true)

                // dispatch(FetchSingleRecordAction(projectCode, allProjects.filter((item) => item.siteId == id)[0].uniqueSiteId))   //from project Databasee
                dispatch(
                    FetchSingleRecordAction(
                        OneSiteDatabaseProjectCode,
                        allProjects.filter((item) => item.siteId == id)[0].uniqueSiteId
                    )
                ); //from network Databasee
            }
        } else {
            // setSiteError(true)
        }
    };

    const setHandler = (e) => {
        setSow((prev) => {
            return { ...prev, selectedSow: e, errorState: false };
        });
    };
    const {
        register,
        getValue,
        required,
        setValue,
        handleSubmit,
        setError,
        formState: { errors },
    } = useForm();

    const onSubmit = async (data) => {
        console.log(data, "dhakjggggg")
        let sector = marketts?.map(item => {
            return item?.value
        })
        let cases = Case?.map(item => {
            console.log(item?.value, "jsadkad")
            return item?.value
        })
        let techs = tech_affected?.map(item => {
            return item?.value
        })
        const data1 = { ...data, 'sector': sector?.join(','), 'Case': cases?.join(','), 'tech_affected': techs?.join(',') }
        console.log(data1, ' datagyyutyyut')

        const newData = new FormData()
        Object.keys(data1).map((i) => {
            console.log("dwdwendwkjndwnf", i)
            newData.append(i, data1[i])
        })




        if (date != null) {
            data1["date"] = moment(date).format("DD/MM/yyyy HH:mm:ss")


        }

        if (reassigned_date != null) {
            data1["reassigned_date"] = moment(reassigned_date).format("DD/MM/yyyy HH:mm:ss")

        }

        const subtractedDateValue = moment(date).subtract(7, 'days').toDate();
        setSubtractedDate(subtractedDateValue);

        // newData.append("site_id", data["site_id"]);
        // newData.append("Analysis_Status", data["Analysis_Status"]);
        // newData.append("inc_ticket", data["inc_ticket"]);
        // newData.append("xPEX", data["xPEX"]);
        // newData.append("bridge_support", data["bridge_support"]);
        // newData.append("assigned_to", data["assigned_to"]);
        // newData.append("shift", data["shift"]);
        // newData.append("hoReqired_to", data["hoReqired_to"]);
        // newData.append("notes", data["notes"]);
        // newData.append("ho_engineer", data["ho_engineer"]);


        // formData.append("type", data["type"])
        // console.log(data , "hi this is data")
        if (data1.unique != undefined) {
            dispatch(
                updateAcccountReducerAction(
                    formData,
                    tmoDallas,
                )
            );
            console.log(updateAcccountReducerAction, 'hhhhhh')
            setCloser(true)
        } else {
            console.log("kjhwgjfdgewjfuew", data)
            dispatch(addUserAction(tmoDallas, data1, undefined, () => { history.push('/mpim/rtwpdashboard') }))
        }



        popUpUpdate({});

        // dispatch(addUserAction(ixModule, data));
        setCloser(true);
    };
    const FetechAllDetail = (id) => {
        // let test = projectIdArray.filter((item) => item.uniqueid == id)[0]
        // console.log(test, "test")
        // setPId(id)
        // setppProjctId(id)
        setProjectId(id);
        let selectedId = id.map((item) => {
            return item.value;
        });
        // dispatch(FetchSingleRecordAction(ranDashboard, selectedId));
        dispatch(FetchSingleRecordAction(OneSiteDatabase, selectedId.join(",")));
        // setCtrCount(1)
        setValue("projectUniqueId", selectedId.join(","));
        // /console.log("FetechAllDetail", id)
    };
    console.log(
        "the col =",
        columnsArray(
            "S.no	Site ID	Project Type	Project ID	RTT Actual	DIY Vendor	Integrator Name	GC	Monitoring start Date	Time Monitoring Start (CST TZ)	0 Hour Status	0 Hr Rprt Sent	24 Hour Status	24 Hr Rprt Sent	48 Hour Status	48 Hr Rprt Sent	72 Hour Status	72 Hr Rprt Sent	Final Status	Integration Alarm Free report	End (CST TZ)	Comments	Unlock Date by RF"
        )
    );
    const findDProjectId = (id, def = 0, pcode = []) => {
        // setCountRender(1)
        // console.log("projectCodeArray", id, projectCodeArray)
        // setppProjectCode(id)

        // setppProjctId('')
        let selectedIds = [];
        let nselectedIds = "";
        if (def == 0) {
            setProjectCode(id);
            selectedIds = id.map((item) => {
                return item.value;
            });
            nselectedIds = selectedIds.join(",");
        } else {
            let testpcode = [];

            // testpcode=projectCodeArray.map((ittm)=>{
            //   if(pcode.indexOf(ittm.label)!=-1){
            //     return {
            //       label:ittm.label,
            //       value:ittm.value
            //     }
            //   }
            // })
            // setProjectCode(testpcode)
            nselectedIds = id;
        }
        // console.log(OneSiteDatabase + id, id, projectCodeArray, "projectCodeArray")

        setSelProjectCode(nselectedIds.split(","));
        setValue("projectCode", nselectedIds);
        setValue("projectcodeUniqueId", selectedIds.join(","));
        dispatch(FetchSingleRecordAction(OneSiteDatabaseProjectId, nselectedIds));
        setoneprid(id);
    };

    useEffect(() => {
        // dispatch(AccountReducerAction(siteDblistSiteId));
        // dispatch(TierListReducerAction(managEngineer));
        // dispatch(AccountReducerAction(allTechnologyApi));
        // // dispatch(AccountReducerAction(allTechnologyApi));
        dispatch(AccountReducerAction(tmoDallas));
        dispatch(AccountReducerAction('/manage_engineer_name'));
        dispatch(AccountReducerAction('/manage_account_name'));
        dispatch(AccountReducerAction('/manage_market_name'));
        dispatch(AccountReducerAction('/manage_technology_name'));

        // dispatch(AccountReducerAction('/manage_gc_name'));
        dispatch(AccountReducerAction('/manage_gc_company'));
        dispatch(AccountReducerAction('/manage_site_id'));
        dispatch(AccountReducerAction('/manage_inc_ticket'));
    }, []);





    // console.log(marketts, "shyam console")

    const ossNames = ["", "POL2ENM", "POL0ENM", "POL3ENM1", "POL4ENM1", "POL5ENM1", "POL7ENM1", "POL8ENM1", "POL9ENM1", "SYL0ENM1", "SYL1ENM1", "SYL2ENM1", "SYL3ENM1", "SYL4ENM1", "SYL5ENM1", "SYL6ENM1", "SYL7ENM1", "SYL8ENM1", "SYL9ENM1", "SYLDENM1"];


    return (
        <fregment className="m-6">

            <form className="form-row" onSubmit={handleSubmit(onSubmit)}>

                <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">INC TICKET<span style={{ color: "red" }}>*</span>    </label>
                    <input
                        style={{ height: "32px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        required
                        id="inputEmail4"
                        name="inc_ticket"
                        {...register("inc_ticket")}
                    />
                </div>



                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">STATUS<span style={{ color: "red" }}>*</span> </label>

                    <select
                        style={{ height: "32px" }}
                        type="text"
                        name="status"
                        required
                        className="custom-select-style form-control"
                        {...register("status", {
                            onChange: (e) => {
                                setalersdadsa(e.target.value)
                            }
                        })}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        <option value="Close">Close</option>
                        <option value="Open">Open</option>
                    </select>
                </div>




                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">ACCOUNT NAME<span style={{ color: "red" }}>*</span></label>

                    <select
                        style={{ height: "32px" }}
                        required
                        type="text"
                        className="custom-select-style form-control"
                        {...register("account_name")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>

                        {
                            accountss?.map(item => {
                                return <option value={item?.accountName}>{item?.accountName}</option>
                            })
                        }
                    </select>
                </div>


                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">MARKET NAME<span style={{ color: "red" }}>*</span></label>

                    <select
                        style={{ height: "32px" }}
                        required
                        type="text"
                        className="custom-select-style form-control"
                        {...register("market_name")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        {
                            marketnames?.map(item => {
                                return <option value={item?.marketName}>{item?.marketName}</option>
                            })
                        }
                    </select>
                </div>
                {/* 
                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">ISSUE OWNER<span style={{ color: "red" }}>*</span></label>
                    <select
                        style={{ height: "32px" }}
                        type="text"
                        className="custom-select-style form-control"
                        required
                        {...register("issue_owner")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        <option value="GC">GC</option>
                        <option value="RF">RF</option>
                        <option value="UMLAUT">UMLAUT</option>
                        <option value="TOWER TEAM">TOWER TEAM</option>
                        <option value="FYI - SR ONLY">FYI - SR ONLY</option>
                    </select>
                </div> */}


                {/* <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">SITE ID<span style={{ color: "red" }}>*</span>    </label>
                    <input
                        style={{ height: "32px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        required
                        id="inputEmail4"
                        name="site_id"
                        {...register("site_id")}
                    />
                </div> */}
                {/* <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">Site ID<span style={{ color: "red" }}>*</span></label>
                    <select
                        style={{ height: "32px" }}
                        required
                        type="text"
                        className="custom-select-style form-control"
                        {...register("site_id")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        {
                            siteid?.map(item => {
                                return <option value={item?.site_id}>{item?.site_id}</option>
                            })
                        }
                    </select>
                </div> */}
                <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">SITE ID</label>
                    <input
                        style={{ height: "40px" }}
                        type="text"
                        className="form-control"
                        id="input "
                        autoComplete={false}
                        list="cars"
                        placeholder="enter Site Id"
                        {...register("site_id")}
                    />
                    <datalist id="cars">{options.site_idss}</datalist>

                </div>


                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">xPEX<span style={{ color: "red" }}>*</span></label>

                    <select
                        style={{ height: "32px" }}
                        type="text"
                        className="custom-select-style form-control"
                        required
                        {...register("xPEX")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        <option value="CAPEX">CAPEX</option>
                        <option value="OPEX">OPEX</option>
                    </select>
                </div>


                <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">Project ID</label>
                    <input
                        style={{ height: "32px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        id="inputEmail4"
                        name="project_id"
                        {...register("project_id")}
                    />
                </div>


                {/* <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">GC<span style={{ color: "red" }}>*</span></label>

                    <select
                        style={{ height: "32px" }}
                        type="text"
                        className="custom-select-style form-control"
                        required
                        {...register("gc")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </div> */}
                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">GC</label>
                    <select
                        style={{ height: "32px" }}

                        type="text"
                        className="custom-select-style form-control"
                        {...register("gc")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        {
                            gc?.map(item => {
                                return <option value={item?.company_name}>{item?.company_name}</option>
                            })
                        }
                    </select>
                </div>




                {/* <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">TECH AFFECTED<span style={{ color: "red" }}>*</span></label>

                    <select
                        style={{ height: "32px" }}
                        type="text"
                        className="custom-select-style form-control"
                        required
                        {...register("tech_affected")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        {
                            techname?.map(item => {
                                return <option value={item?.technologyName}>{item?.technologyName}</option>
                            })
                        }
                    </select>
                </div> */}

                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">TECH AFFECTED<span style={{ color: "red" }}>*</span></label>


                    <MultiSelect
                        className="light"
                        required
                        onChange={setTech}
                        value={tech_affected}
                        options={options.multipleTechno}
                    />
                </div>


                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">SECTOR<span style={{ color: "red" }}>*</span>
                    </label>
                    <MultiSelect
                        className="light"
                        required
                        onChange={setmarketts}
                        value={marketts}
                        options={mStatusArry}
                    />
                </div>


                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">CATEGORY<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                        style={{ height: "32px" }}
                        type="text"
                        className="custom-select-style form-control"
                        required
                        {...register("category")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        <option value="PIM - Internal">PIM - Internal</option>
                        <option value="PIM - External">PIM - External</option>
                        <option value="External Interference">External Interference</option>
                        <option value="PIM Internal / External Interference">PIM Internal / External Interference</option>
                        <option value="PIM Internal / PIM External">PIM Internal / PIM External</option>
                        <option value="No Issues">No Issues</option>
                        <option value="PIM - External / External Interference">PIM - External / External Interference</option>
                    </select>
                </div>


                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">MCPS ENGINEER<span style={{ color: "red" }}>*</span></label>

                    <select
                        style={{ height: "32px" }}
                        type="text"
                        className="custom-select-style form-control"
                        required
                        {...register("mcps_engineer")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        {
                            engineers?.map(item => {
                                return <option value={item?.name}>{item?.name}</option>
                            })
                        }
                    </select>
                  
                </div>


                <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">WORK LOG</label>
                    <input
                        style={{ height: "32px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        id="inputEmail4"
                        name="work_log"
                        {...register("work_log")}
                    />
                </div>

                {/* <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">GO BACK DATE</label>
                    <input
                        style={{ height: "32px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        id="inputEmail4"
                        name="go_back_date"
                        {...register("go_back_date")}
                    />
                </div> */}


                {/* <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">CASE<span style={{ color: "red" }}></span></label>

                    <select
                        style={{ height: "32px" }}
                        type="text"
                        className="custom-select-style form-control"

                        {...register("case")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                    </select>
                </div> */}

                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">CASE<span style={{ color: "red" }}>*</span>
                    </label>
                    <MultiSelect
                        className="light"
                        required
                        onChange={setcase}
                        value={Case}
                        options={caseStatusarry}
                    />
                </div>


                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">INC ASSIGNED TO<span style={{ color: "red" }}>*</span>
                    </label>

                    <select
                        style={{ height: "32px" }}
                        type="text"
                        className="custom-select-style form-control"
                        required
                        {...register("inc_assigned")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        <option value="PAG">MCPS</option>
                        <option value="PAG">PAG</option>
                        <option value="UMLAUT">UMLAUT</option>
                        <option value="FOPS">FOPS</option>
                        <option value="TMO-RF">TMO-RF</option>
                    </select>

                    {/* {errors.sheduleShift && (
            <p className="error">{errors.sheduleShift.message}</p>
          )} */}
                </div>


                <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">ASSIGNED GROUP<span style={{ color: "red" }}>*</span></label>
                    <input
                        style={{ height: "32px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        required
                        placeholderText='ASSIGNED GROUP'
                        id="inputEmail4"
                        name="assigned_group"
                        {...register("assigned_group")}
                    />
                </div>


                <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">ASSIGNEE<span style={{ color: "red" }}>*</span></label>
                    <input
                        style={{ height: "32px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        required
                        id="inputEmail4"
                        name="assignee"
                        {...register("assignee")}
                    />
                </div>



                <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">
                        DATE ASSIGNED<span style={{ color: "red" }}>*</span>
                    </label>
                    <div
                        style={{ height: "40px" }}
                        type="text"
                        min={0}
                        max={100}
                        // className="form-control"
                        required
                        id="inputEmail4"
                        name="date"
                    >


                        <DatePicker


                            {...register("date")}
                            placeholderText="MM/DD/YYYY hh:mm"
                            id="color-of-datepicker"
                            // className="date-picker-changes"
                            className="newFormatting date-picker-changes fff "

                            // popperPlacement='left'
                            selected={date}
                            autoComplete={"off"}
                            showTimeSelect
                            timeIntervals={1}
                            timeCaption="Time"
                            onChange={(e) => {
                                dfefdewdewdate(e);
                                // setfenddate(e);
                            }}
                            dateFormat="dd/MM/yyyy hh:mm:ss"

                        />

                    </div>
                </div>

                {/* <div className="form-group col-md-3">
                    <label htmlFor="subtractedDays"> AGING</label>
                    <div style={{ height: "40px" }}>
                        <input
                            {...register("aging")}
                            type="text"
                            value={subtractedDays}
                            readOnly
                            className="form-control"
                            onChange={(e) => {
                                setSubtractedDays(e);

                            }}
                        />
                    </div>
                </div> */}

                {/* <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">DATE REASSIGNED</label>
                    <input
                        style={{ height: "32px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        placeholderText='DATE REASSIGNED'
                        id="inputEmail4"
                        name="reassigned_group"
                        {...register("reassigned_group")}
                    />
                </div> */}
                {/* <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">
                        DATE REASSIGNED<span style={{ color: "red" }}>*</span>
                    </label>
                    <div
                        style={{ height: "40px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        placeholderText='DATE REASSIGNED'
                        required
                        id="inputEmail4"
                        name="reassigned_date"
                    >
                        <DatePicker
                            {...register("reassigned_date")}
                            placeholderText="DD/MM/YYYY"
                            id="color-of-datepicker"
                            className="date-picker-changes "
                            popperPlacement='left'
                            selected={reassigned_date}
                            autoComplete={"off"}
                            onChange={(e) => {
                                dfedate(e);
                                // setfenddate(e);
                            }}
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                </div> */}
                <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">
                        DATE REASSIGNED
                    </label>
                    <div
                        style={{ height: "40px" }}
                        type="text"
                        min={0}
                        max={100}
                        // className="form-control"
                        placeholderText='DATE REASSIGNED'
                        required
                        id="inputEmail4"
                        name="reassigned_date"
                    >


                        {console.log("reassigned_date", reassigned_date)}
                        <DatePicker
                            {...register("reassigned_date")}
                            placeholderText="MM/DD/YYYY hh:mm"
                            id="color-of-datepicker"
                            // className="date-picker-changes"
                            className="newFormatting date-picker-changes fff "

                            // popperPlacement="left"
                            selected={reassigned_date}
                            autoComplete={"off"}

                            dateFormat="dd/MM/yyyy hh:mm:ss"
                            showTimeSelect
                            timeIntervals={1}
                            timeCaption="Time"
                            onChange={(e) => {
                                dfedate(e);
                                // setfenddate(e);
                            }}
                        />
                    </div>
                </div>


                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">PIER STATUS<span style={{ color: "red" }}>*</span></label>
                    <select
                        style={{ height: "32px" }}
                        type="text"
                        className="custom-select-style form-control"
                        required
                        {...register("pier")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        <option value="Closed">Closed</option>
                        <option value="Assigned">Assigned</option>
                        <option value="Waiting">Waiting</option>
                        <option value="Resolved">Resolved</option>
                        <option value="Terminated">Terminated</option>
                        <option value="Working">Working</option>
                    </select>
                </div>

                <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">RESOLUTION<span style={{ color: "red" }}>*</span></label>
                    <input
                        style={{ height: "32px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        required={alersdadsa == "Close" ? true : false}
                        placeholderText='RESOLUTION'
                        id="inputEmail4"
                        name="resolution"
                        {...register("resolution")}
                    />
                </div>
                {/* <div className="form-group col-md-3">
                    <label for="exampleFormControlSelect1">NOTES<span style={{ color: "red" }}>*</span></label>
                    <input
                        style={{ height: "32px" }}
                        type="text"
                        min={0}
                        max={100}
                        className="form-control"
                        
                        placeholderText='Notes'
                        id="inputEmail4"
                        name="notes"
                        {...register("notes")}
                    />
                </div> */}



                <div
                    className="d-flex justify-content-center mb-5"
                    style={{ width: "100%" }}
                >
                    <button
                        type="submit"
                        className="btn btn-primary btn-xs py-2 mr-2 px-4 mt-2"

                    >
                        Submit
                    </button>

                    {/* <button
            className="btn btn-danger btn-xs py-2  px-4 mr-2 mt-2"
            onClick={() => history.push("/PAG/ix/dashboard")}
          >
            Back
          </button> */}
                </div>
            </form>
        </fregment>
    );
};

export default TmoDallas;
